
class MapWrapper {
  constructor(map) {
    this._leafletMap = map
    this._layers = {}
  }

  getLayer(name) {
    return this._layers[name]
  }

  setLayer(name, layer) {
    this._layers[name] = layer
    return this
  }

  addLayer(name, layer) {
    this.removeLayer(name)
    this.setLayer(name, layer)
    this._leafletMap.addLayer(layer)
    return this
  }

  removeLayer(name) {
    const layer = this.getLayer(name)
    if (layer && this._leafletMap.hasLayer(layer)) {
      this._leafletMap.removeLayer(layer)
    }
    return this
  }

  replaceLayer(name, layer) {
    this.removeLayer(name).addLayer(name, layer)
  }

  bindZoomAnim(name) {
    const layer = this.getLayer(name)
    if (layer && this._leafletMap.hasLayer(layer)) {
      this._leafletMap.on('zoomanim', layer.redraw, layer)
    }
  }

  unbindZoomAnim(name) {
    const layer = this.getLayer(name)
    if (layer && this._leafletMap.hasLayer(layer)) {
      this._leafletMap.off('zoomanim', layer.redraw, layer)
    }
  }
}

export default MapWrapper